export enum Para
{
    style = 'style' ,
    ul = 'ul',
    ol = 'ol',
    paragraph='paragraph',
    height='height'
}

